/* Serment — refonte 2026-10-20 : interactions (loupe produit, inclinaison des cartes, reflet des boutons, curseur) */
(function () {
  'use strict';
  var doc = document, body = doc.body;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var ANIM = !reduce && !body.classList.contains('no-anim');
  var fr = (doc.documentElement.lang || '').indexOf('fr') === 0;

  /* 1. Reflet doré qui suit le pointeur sur les boutons */
  if (fine && ANIM) {
    doc.addEventListener('mousemove', function (e) {
      var b = e.target.closest && e.target.closest('.rf-btn, .atc, .buy-now, .sticky-atc .btn');
      if (!b) return;
      var r = b.getBoundingClientRect();
      b.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
    }, { passive: true });
  }

  /* 2. Inclinaison douce des cartes produit et des arches */
  if (fine && ANIM) {
    doc.addEventListener('mousemove', function (e) {
      var card = e.target.closest && e.target.closest('.rfc, .rf-arch, .rf-vw-cover');
      if (!card) return;
      var vis = card.querySelector('.rfc-media, .rf-arch-img') || card;
      var r = vis.getBoundingClientRect();
      if (!r.width) return;
      var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
      vis.style.transition = 'transform .15s ease-out';
      vis.style.transform = 'perspective(900px) rotateX(' + (-py * 5) + 'deg) rotateY(' + (px * 5) + 'deg) translateZ(0)';
      card.__tilted = vis;
    }, { passive: true });
    doc.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('.rfc, .rf-arch, .rf-vw-cover');
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      var vis = card.__tilted; if (!vis) return;
      vis.style.transition = 'transform .7s cubic-bezier(.2,.7,.2,1)';
      vis.style.transform = '';
    }, { passive: true });
  }

  /* 3. Curseur or : libellé « Découvrir » sur les cartes de la refonte */
  if (fine && ANIM) {
    doc.addEventListener('mouseover', function (e) {
      var lab = doc.querySelector('.mcur-label'); if (!lab) return;
      var c = e.target.closest && e.target.closest('.rfc, .rf-arch, .rf-tile, .rf-mega-promo, .rf-vw-cover');
      if (c) { lab.textContent = c.getAttribute('data-cursor') || (fr ? 'Découvrir' : 'Discover'); body.classList.add('mcur-label-on'); }
    });
  }

  /* 4. Loupe produit : clic sur la photo = zoom ×2,2 qui suit le pointeur (desktop) */
  if (fine && ANIM && window.matchMedia('(min-width: 990px)').matches) {
    doc.querySelectorAll('.g-main').forEach(function (g) {
      var setOrigin = function (e) {
        var r = g.getBoundingClientRect();
        g.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(2) + '%');
        g.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(2) + '%');
      };
      g.addEventListener('click', function (e) {
        if (e.target.closest('.g-nav, button, a')) return;
        setOrigin(e);
        g.classList.toggle('is-zoom');
      });
      g.addEventListener('mousemove', function (e) { if (g.classList.contains('is-zoom')) setOrigin(e); }, { passive: true });
      g.addEventListener('mouseleave', function () { g.classList.remove('is-zoom'); });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') g.classList.remove('is-zoom'); });
    });
  }

  /* 5. Bande promesse collante (fiche produit) : légère ombre une fois collée */
  var ps = doc.getElementById('rfPstrip');
  if (ps && 'IntersectionObserver' in window) {
    var sentinel = doc.createElement('div'); sentinel.style.cssText = 'position:absolute;height:1px;width:1px;top:-1px';
    ps.parentNode.insertBefore(sentinel, ps);
    new IntersectionObserver(function (en) { ps.classList.toggle('is-stuck', !en[0].isIntersecting); }, { rootMargin: '-' + (parseInt(getComputedStyle(doc.documentElement).getPropertyValue('--rf-head-h')) || 72) + 'px 0px 0px 0px' }).observe(sentinel);
  }

  /* 6. Éventail Vowery : les couvertures se redressent au survol */
  doc.querySelectorAll('[data-rf-fan]').forEach(function (fan) {
    fan.addEventListener('mouseenter', function () { fan.classList.add('is-open'); });
    fan.addEventListener('mouseleave', function () { fan.classList.remove('is-open'); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) { fan.classList.add('is-in'); } }, { threshold: 0.4 }).observe(fan);
    } else { fan.classList.add('is-in'); }
  });
  /* 7. Sélecteur de taille discret : une boîte, un panneau, les pastilles restent le moteur */
  /* 27 oct 2026 : seule la vraie variante « sur mesure » (mot-clé du bloc taille sur mesure, ex. « personnalisée » / « custom »)
     devient le bouton « Sur mesure ». Une taille sans .sz-num (ex. la variante « 16 S », affichée 16W) redevient une taille normale :
     avant, elle s'affichait en second « Sur mesure » et sélectionnait en réalité la taille 16 S. Les tailles sont ensuite triées. */
  var csKw = (function () { var el = doc.querySelector('[data-custom-size]'); return ((el && el.getAttribute('data-keyword')) || '').toLowerCase(); })();
  var isCustom = function (p, inp) {
    var v = ((inp && inp.value) || p.textContent || '').toLowerCase();
    if (csKw && v.indexOf(csKw) > -1) return true;
    return /custom|personnalis|sur mesure|made to measure/.test(v);
  };
  var buildSize = function () {
    var g = doc.querySelector('[data-opt-group].sz-on'); if (!g || g.dataset.rfSize) return;
    var pills = Array.prototype.slice.call(g.querySelectorAll('.v-pill')); if (pills.length < 3) return;
    g.dataset.rfSize = '1';
    var wrap = doc.createElement('div'); wrap.className = 'rf-size';
    var btn = doc.createElement('button'); btn.type = 'button'; btn.className = 'rf-size-btn'; btn.setAttribute('aria-haspopup', 'listbox');
    var panel = doc.createElement('div'); panel.className = 'rf-size-panel';
    var grid = doc.createElement('div'); grid.className = 'rf-size-grid';
    var opts = [];
    var close = function () { wrap.classList.remove('is-open'); g.classList.remove('rf-size-open'); btn.setAttribute('aria-expanded', 'false'); };
    var open = function () { wrap.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    pills.forEach(function (p) {
      var inp = p.querySelector('input'); var num = p.querySelector('.sz-num'), eu = p.querySelector('.sz-eu');
      var o = doc.createElement('button'); o.type = 'button';
      if (num) { o.className = 'rf-size-opt'; o.innerHTML = '<span>' + num.textContent + '</span><small>' + (eu ? eu.textContent : '') + '</small>'; }
      else if (!isCustom(p, inp)) {
        var lab = (p.textContent || '').replace(/\s+/g, '');
        var m = lab.match(/^(\d+)/);
        var sp = doc.createElement('span'); sp.textContent = lab;
        var sm = doc.createElement('small'); sm.textContent = m ? 'EU ' + (parseInt(m[1], 10) + 30) : '';
        o.className = 'rf-size-opt'; o.appendChild(sp); o.appendChild(sm);
      }
      else { o.className = 'rf-size-opt rf-size-opt--custom'; o.textContent = (fr ? 'Sur mesure · cousue à vos mesures' : 'Custom size · cut to your measurements'); }
      o.__inp = inp; o.__pill = p;
      o.addEventListener('click', function () { if (inp && !inp.checked) inp.click(); close(); });
      opts.push(o); grid.appendChild(o);
    });
    var sizeKey = function (o) {
      if (o.classList.contains('rf-size-opt--custom')) return 1e6;
      var s = o.querySelector('span'), t = s ? s.textContent : '';
      var n = parseInt(t, 10); if (isNaN(n)) return 5e5;
      return (/[a-z]/i.test(t) ? 1000 : 0) + n;
    };
    opts.slice().sort(function (a, b) { return sizeKey(a) - sizeKey(b); }).forEach(function (o) { grid.appendChild(o); });
    var foot = doc.createElement('div'); foot.className = 'rf-size-foot';
    var sg = doc.getElementById('sizeGuideBtn');
    foot.innerHTML = '<span>' + (fr ? 'Entre deux tailles ? Prenez la plus grande.' : 'Between two sizes? Take the larger one.') + '</span>' + (sg ? '<button type="button" data-rf-sg>' + (fr ? 'Guide des tailles' : 'Size guide') + '</button>' : '');
    panel.appendChild(grid); panel.appendChild(foot); wrap.appendChild(btn); wrap.appendChild(panel);
    g.insertBefore(wrap, g.firstChild);
    var sgb = foot.querySelector('[data-rf-sg]'); if (sgb) sgb.addEventListener('click', function () { close(); sg.click(); });
    var update = function () {
      var cur = null; opts.forEach(function (o) { var on = o.__inp && o.__inp.checked; o.classList.toggle('on', !!on); if (on) cur = o; });
      if (!cur) { btn.className = 'rf-size-btn is-empty'; btn.innerHTML = '<span>' + (fr ? 'Choisir ma taille' : 'Choose my size') + '</span>'; return; }
      btn.className = 'rf-size-btn';
      var num = cur.querySelector('span'), eu = cur.querySelector('small');
      if (num) btn.innerHTML = '<span>' + (fr ? 'Taille' : 'Size') + ' · <b>US ' + num.textContent + '</b><small>' + (eu ? eu.textContent : '') + '</small></span>';
      else btn.innerHTML = '<span>' + (fr ? 'Taille · <b>Sur mesure</b>' : 'Size · <b>Custom</b>') + '</span>';
    };
    btn.addEventListener('click', function () { wrap.classList.contains('is-open') ? close() : open(); });
    g.addEventListener('change', update);
    doc.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    update();
  };
  [0, 120, 500, 1500].forEach(function (t) { setTimeout(buildSize, t); });
  window.addEventListener('load', function () { setTimeout(buildSize, 50); });

  /* 7b. Les ornements de titre se déroulent à l'entrée */
  if ('IntersectionObserver' in window) { var hio = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); hio.unobserve(e.target); } }); }, { threshold: .4 }); doc.querySelectorAll('.rf-sec-head').forEach(function (h) { hio.observe(h); }); } else { doc.querySelectorAll('.rf-sec-head').forEach(function (h) { h.classList.add('is-in'); }); }

  /* 8. Défilement des arches sur mobile : amorce, points, fin de l'indice au premier geste */
  doc.querySelectorAll('[data-rf-scroller]').forEach(function (sc) {
    var track = sc.querySelector('.rf-arches'); var dots = sc.querySelector('.rf-scroller-dots'); if (!track) return;
    var items = track.children.length; if (dots) { for (var i = 0; i < items; i++) { var d = doc.createElement('i'); if (!i) d.className = 'on'; dots.appendChild(d); } }
    var tick = false;
    track.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false;
        if (track.scrollLeft > 12) sc.classList.add('is-scrolled');
        if (dots && track.firstElementChild) { var w = track.firstElementChild.getBoundingClientRect().width + 12; var idx = Math.min(items - 1, Math.round(track.scrollLeft / w)); Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === idx); }); }
      });
    }, { passive: true });
  });
  /* 8b. Récemment consultées avant « Dans le même esprit » */
  var rcn = doc.querySelector('[data-rf-recent]'), rsp = rcn && rcn.previousElementSibling;
  if (rsp && rsp.classList.contains('rf-rail')) rsp.parentNode.insertBefore(rcn, rsp);

  /* 9. Gadgets : parallaxe du hero, boutons magnétiques, miniatures au survol */
  var hm = doc.querySelector('.rf-hero3-media img');
  if (hm && ANIM && fine) {
    var ht = false;
    window.addEventListener('scroll', function () {
      if (ht) return; ht = true;
      requestAnimationFrame(function () { ht = false; var y = Math.min(window.scrollY, 900); hm.style.transform = 'scale(1.04) translateY(' + (y * 0.12) + 'px)'; });
    }, { passive: true });
    hm.addEventListener('animationend', function () { hm.style.animation = 'none'; });
  }
  if (fine && ANIM) {
    doc.querySelectorAll('.rf-btn3--velvet, .buy-now').forEach(function (b) {
      b.addEventListener('mousemove', function (e) { var r = b.getBoundingClientRect(); var dx = (e.clientX - r.left - r.width / 2) / r.width, dy = (e.clientY - r.top - r.height / 2) / r.height; b.style.transform = 'translate(' + (dx * 6) + 'px,' + (dy * 4) + 'px)'; });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
    doc.querySelectorAll('.g-thumb').forEach(function (t) { t.addEventListener('mouseenter', function () { t.click(); }); });
  }

  /* 10. Barre d'achat collante : « Ajouter au panier » à côté d'« Acheter maintenant » (l'accent reste sur l'achat immédiat) */
  var sbar = doc.getElementById('stickyAtc');
  if (sbar && !sbar.querySelector('.rf-sticky-cart')) {
    var sBuy = sbar.querySelector('[data-sticky-add]') || sbar.querySelector('button');
    var pForm = doc.querySelector('form[action*="/cart/add"]');
    var pAtc = pForm && (pForm.querySelector('.rf-atc2') || pForm.querySelector('[type="submit"]:not([data-buy-now])'));
    if (sBuy && pAtc) {
      var sCart = doc.createElement('button'); sCart.type = 'button'; sCart.className = 'btn no-arrow rf-sticky-cart';
      sCart.textContent = fr ? 'Ajouter au panier' : 'Add to cart';
      sCart.addEventListener('click', function () {
        if (pForm.checkValidity && !pForm.checkValidity()) { var br = doc.querySelector('.buy-row'); if (br) br.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        pAtc.click();
      });
      sBuy.parentNode.insertBefore(sCart, sBuy);
      sbar.classList.add('rf-sb2');
    }
  }

  /* 11. Filtres sur mobile : l'en-tête et la croix restent visibles pendant le défilement, sous la barre du site */
  var rfF = doc.getElementById('rfFilters'), rfFt = rfF && rfF.querySelector('.rf-f-top');
  if (rfFt) {
    var siteHead = doc.querySelector('.rf-head');
    var fTop = function () {
      var pt = parseFloat(getComputedStyle(rfF).paddingTop) || 0;
      var cover = 0;
      if (siteHead && getComputedStyle(rfF).position === 'fixed') { cover = Math.max(0, siteHead.getBoundingClientRect().bottom - rfF.getBoundingClientRect().top); }
      rfFt.style.top = (cover - pt) + 'px';
    };
    fTop();
    rfF.addEventListener('scroll', fTop, { passive: true });
    window.addEventListener('resize', fTop);
    doc.addEventListener('click', function () { setTimeout(fTop, 60); setTimeout(fTop, 400); }, true);
  }
  var rfSt = doc.createElement('style');
  rfSt.textContent = '#rfFilters .rf-f-top{position:sticky;top:0;z-index:6;background:#FAF6EE;padding-top:14px;padding-bottom:14px;box-shadow:0 10px 14px -14px rgba(42,34,28,.45)}' +
    '#stickyAtc.rf-sb2{gap:10px}' +
    '#stickyAtc .rf-sticky-cart{background:transparent!important;color:#2A221C!important;border:1px solid rgba(42,34,28,.85)!important;box-shadow:none!important;white-space:nowrap}' +
    '#stickyAtc .rf-sticky-cart:hover{background:#2A221C!important;color:#F6E7C9!important}' +
    '@media(max-width:900px){#stickyAtc.rf-sb2>div{display:none!important}#stickyAtc.rf-sb2>button{flex:1 1 0;min-width:0;margin:0!important;padding-left:8px!important;padding-right:8px!important;font-size:10px!important;letter-spacing:.14em!important}#stickyAtc.rf-sb2>[data-sticky-add]{flex-grow:1.3}}';
  doc.head.appendChild(rfSt);
})();
